import { render, staticRenderFns } from "./cs-widget.vue?vue&type=template&id=3cda08e6"
import script from "./cs-widget.vue?vue&type=script&lang=js"
export * from "./cs-widget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports